import React from "react";
import styled from "styled-components";
import PretendardText from "../atoms/text/pretendardText";
import { formatNumberWithCommas } from "./../../util/formatNumber";

const TableCount = (props) => {
  return (
    <>
      <TableCountWrapper>
        <PretendardText
          style={{
            fontSize: "14px",
            fontWeight: "600",
            lineHeight: "22.75px",
            color: "rgba(181, 181, 181, 0.5)",
          }}
        >
          {props.fullText ? props.fullText : `전체 ${props.text}`}
        </PretendardText>
        <PretendardText
          style={{
            fontSize: "14px",
            fontWeight: "600",
            lineHeight: "22.75px",
            color: "#aaa",
          }}
        >
          {props.count ? formatNumberWithCommas(props.count) : "0"}
        </PretendardText>
      </TableCountWrapper>
    </>
  );
};

export default TableCount;

const TableCountWrapper = styled.div.attrs((props) => {})`
  display: flex;
  align-items: center;
  gap: 7px;
`;
